import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = ["id", "innerHTML"];
var _hoisted_2 = ["id", "data-cy", "aria-required", "aria-controls", "aria-labelledby", "aria-expanded", "aria-activedescendant", "aria-invalid", "aria-describedby"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  "class": "tw-inline-flex"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = ["data-cy"];
var _hoisted_7 = ["id", "aria-selected", "onClick", "onMouseover"];
var _hoisted_8 = {
  "class": "tw-inline-block tw-cursor-pointer"
};
var _hoisted_9 = ["name", "checked", "onInput"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["id", "arial-live", "innerHTML"];
var _hoisted_12 = ["id", "arial-live", "innerHTML"];
import { watch, ref, onMounted, onUnmounted, computed } from "vue";
import { useKeyboardController } from "@wkComposables/useKeyboardController";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
import { WarningIconRounded } from "@vueEntry/SvgIcons/WarningIconRounded";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'AccessibleSelect',
  props: {
    label: {
      "default": ""
    },
    dropdownPosition: {
      "default": "bottom"
    },
    namespace: {},
    options: {},
    modelValue: {
      "default": function _default() {
        return {
          id: "",
          label: ""
        };
      }
    },
    isValid: {
      type: [Boolean, null],
      "default": null
    },
    feedback: {}
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var isDropdownOpen = ref(false);
    var btnEl = ref(null);
    var hasValue = computed(function () {
      return !!props.modelValue.label;
    });
    var emits = __emit;
    var _useKeyboardControlle = useKeyboardController({
        optionsLength: props.options.length,
        isDropdownOpen: isDropdownOpen
      }),
      activeIdx = _useKeyboardControlle.activeIdx,
      selectedIdx = _useKeyboardControlle.selectedIdx;
    var handleChange = function handleChange(selectItem) {
      isDropdownOpen.value = false;
      emits("update:modelValue", selectItem);
    };
    watch(selectedIdx, function (curIdx) {
      handleChange(props.options[curIdx]);
      isDropdownOpen.value = false;
    });
    var handleBodyClick = function handleBodyClick() {
      isDropdownOpen.value = false;
    };
    onMounted(function () {
      document.addEventListener("click", handleBodyClick);
    });
    onUnmounted(function () {
      document.removeEventListener("click", handleBodyClick);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        "class": _normalizeClass(["tw-relative tw-flex tw-items-center", [_ctx.label ? 'tw-h-[52px]' : 'tw-h-[42px]', _ctx.$attrs['class']]])
      }, [_ctx.label ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        id: "".concat(_ctx.namespace, "_label"),
        "class": _normalizeClass(["tw-absolute tw-font-medium tw-transition-all tw-ease-in-out", [hasValue.value ? '-tw-top-1 tw-left-[22px] tw-text-w-black as-floating' : 'tw-top-4 tw-left-4 tw-text-w-gray as-inline', _ctx.$attrs['label-classes']]]),
        innerHTML: _ctx.label
      }, null, 10 /* CLASS, PROPS */, _hoisted_1)) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "lefticon"), _createElementVNode("button", {
        id: "".concat(_ctx.namespace, "_btn"),
        ref_key: "btnEl",
        ref: btnEl,
        type: "button",
        "data-cy": _ctx.$attrs['data-cy'],
        "class": _normalizeClass(["tw-px-4 tw-bg-white tw-w-full tw-h-full tw-text-left focus-visible:tw-outline-0 tw-truncate tw-peer tw-flex tw-items-center tw-justify-between", _ctx.$attrs['btn-classes']]),
        "aria-required": !!_ctx.$attrs['required'],
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-controls": "".concat(_ctx.namespace, "_dropdown"),
        "aria-labelledby": "".concat(_ctx.namespace, "_label ").concat(_ctx.namespace, "_btn"),
        "aria-expanded": isDropdownOpen.value,
        "aria-activedescendant": _unref(activeIdx) >= 0 && isDropdownOpen.value ? "".concat(_ctx.namespace, "_element_").concat(_ctx.options[_unref(activeIdx)].label) : '',
        "aria-invalid": props.isValid === false,
        "aria-describedby": props.isValid === false ? "".concat(_ctx.namespace, "_invalid_msg") : undefined,
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return isDropdownOpen.value = !isDropdownOpen.value;
        }, ["stop"]))
      }, [_createElementVNode("span", {
        "class": _normalizeClass(_ctx.$attrs['btn-text-classes']),
        innerHTML: _ctx.modelValue.visibleLabel || _ctx.modelValue.label
      }, null, 10 /* CLASS, PROPS */, _hoisted_3), _createElementVNode("span", _hoisted_4, [props.isValid == false ? (_openBlock(), _createBlock(_unref(WarningIconRounded), {
        key: 0,
        "class": "tw-mr-1",
        width: 20,
        height: 20
      })) : _createCommentVNode("v-if", true), _createVNode(_unref(ArrowIcon), {
        "class": _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none", isDropdownOpen.value && 'tw-rotate-180']),
        width: 18,
        height: 18,
        "stroke-color": _ctx.isValid ? '#2B5DFF' : _ctx.isValid === false ? '#FA4F64' : '#222'
      }, null, 8 /* PROPS */, ["class", "stroke-color"])])], 10 /* CLASS, PROPS */, _hoisted_2), _createElementVNode("fieldset", {
        "aria-hidden": "true",
        "class": _normalizeClass(["tw-absolute -tw-top-[1px] tw-right-0 tw-left-0 tw-bottom-0 tw-px-2 tw-border tw-rounded-xs tw-border-solid tw-cursor-pointer tw-pointer-events-none peer-focus:tw-border-2 peer-focus:tw-border-w-primary peer-focus-visible:tw-border-2 peer-focus-visible:tw-border-w-primary peer-aria-invalid:tw-border-w-danger", [_ctx.label ? 'tw-h-12' : 'tw-h-[42px]', _ctx.$attrs['fieldset-classes'], _ctx.isValid ? 'tw-border-w-primary' : _ctx.isValid === false ? 'tw-border-w-danger' : 'tw-border-w-secondary']])
      }, [_ctx.label ? (_openBlock(), _createElementBlock("legend", {
        key: 0,
        "class": _normalizeClass([_ctx.$attrs['legend-classes'], "tw-ml-2 tw-h-3"])
      }, [_createElementVNode("span", {
        "class": _normalizeClass(["tw-mx-5px", _ctx.modelValue.label ? 'tw-invisible' : 'tw-hidden']),
        innerHTML: _ctx.label
      }, null, 10 /* CLASS, PROPS */, _hoisted_5)], 2 /* CLASS */)) : _createCommentVNode("v-if", true)], 2 /* CLASS */), _createElementVNode("ul", {
        "data-cy": _ctx.$attrs['data-cy'] && "".concat(_ctx.$attrs['data-cy'], "_dropdown"),
        role: "listbox",
        tabindex: -1,
        "aria-multiselectable": false,
        "class": _normalizeClass(["tw-absolute tw-w-full tw-z-10 tw-min-w-full tw-max-h-[225px] tw-no-scrollbar tw-overflow-y-auto", [{
          'tw-overflow-hidden tw-w-0 tw-h-0': !isDropdownOpen.value
        }, {
          'tw-border tw-border-solid tw-border-w-secondary tw-bg-white tw-rounded-xs': isDropdownOpen.value
        }, {
          'tw-bottom-[55px]': _ctx.dropdownPosition === 'top'
        }, {
          'tw-top-[55px]': _ctx.dropdownPosition === 'bottom'
        }, _ctx.$attrs['dropdown-classes']]]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, function (selectItem, idx) {
        return _openBlock(), _createElementBlock("li", {
          id: "".concat(_ctx.namespace, "_element_").concat(_ctx.options[idx].label),
          key: "".concat(selectItem.label, "_").concat(idx),
          role: "option",
          "aria-selected": _unref(activeIdx) === idx,
          "class": _normalizeClass(["aria-selected:tw-bg-w-cultured aria-selected:tw-rounded-xs tw-px-20px tw-py-10px tw-m-1 tw-cursor-pointer", _ctx.$attrs['dropdown-item-classes']]),
          onClick: _withModifiers(function ($event) {
            return handleChange(selectItem);
          }, ["stop"]),
          onMouseover: _withModifiers(function ($event) {
            return activeIdx.value = idx;
          }, ["stop"])
        }, [_createElementVNode("label", _hoisted_8, [_createElementVNode("input", {
          tabindex: "-1",
          "class": "tw-appearance-none",
          name: "".concat(_ctx.namespace, "_radio"),
          type: "radio",
          checked: selectItem.label === _ctx.modelValue.label,
          onInput: _withModifiers(function ($event) {
            return handleChange(selectItem);
          }, ["stop"])
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9), _createElementVNode("span", {
          innerHTML: selectItem.label
        }, null, 8 /* PROPS */, _hoisted_10)])], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7);
      }), 128 /* KEYED_FRAGMENT */))], 10 /* CLASS, PROPS */, _hoisted_6)], 2 /* CLASS */), _ctx.feedback ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_ctx.feedback.valid ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        id: "".concat(_ctx.namespace, "_valid_msg"),
        "arial-live": _ctx.$attrs['aria-live'],
        "class": "tw-mb-2 tw-text-sm",
        innerHTML: _ctx.isValid ? _ctx.feedback.valid : ''
      }, null, 8 /* PROPS */, _hoisted_11)) : _createCommentVNode("v-if", true), _ctx.feedback.invalid ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        id: "".concat(_ctx.namespace, "_invalid_msg"),
        "arial-live": _ctx.$attrs['aria-live'],
        "class": "tw-mb-2 tw-text-sm tw-text-w-danger",
        innerHTML: _ctx.isValid === false ? _ctx.feedback.invalid : ''
      }, null, 8 /* PROPS */, _hoisted_12)) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */);
    };
  }
}));